import gql from 'graphql-tag'

const reservationTransfersGetQuery = gql`
  query reservationTransfersGet($criteria: Object) {
    reservationTransfersGet(input: { criteria: $criteria, nested: true })
      @rest(type: "ReservationTransfersResult", method: "POST", path: "reservation/transfer/list") {
      results
    }
  }
`

export default reservationTransfersGetQuery
